import * as React from 'react';
var CheckIcon = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: "CheckIcon " + (className || ''), width: "14", height: "10", viewBox: "0 0 14 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 5.19231L1.4 3.84615L5 7.30769L12.6 0L14 1.34615L5 10L0 5.19231Z", fill: "#FB6910" })));
};
export default CheckIcon;
